// Components

// Styles
import { ContainerInput, ContainerGroup, ContainerContent, ContainerBox, TextSwitch } from './styles'

// Utils
import { useTranslation } from 'react-i18next'
import { SelectInput } from '../../../SelectInput'
import { AntSwitch, AntSwitchBorderedControlLabel, CustomFormLabel, CustomTextArea, CustomTextField, RiskImg } from '../../../../pages/styles'

export const RiskControlForm = ({
    isNew, form, errors, handleChange, handleState, maxItem = 1, impactOptions,
    probabilityOptions,
    riskOptions,
    matrizPng
}) => {
    const { t } = useTranslation();

    return (
        <ContainerBox>
            <ContainerContent>

                <ContainerGroup isFirsts>
                    <ContainerInput>
                        <CustomFormLabel>{t('riskLevel.table.item')}:</CustomFormLabel>
                        <CustomTextField
                            type='number'
                            value={form.item}
                            size="small"
                            onChange={e => {
                                let value = Number(e.target.value);

                                if (value > maxItem + 1) value = maxItem + 1;
                                handleChange({ target: { value } }, 'item');
                            }}
                            inputProps={{
                                min: 0,
                                max: maxItem
                            }}
                            onKeyDown={(e) => {
                                if (['-', '.', ','].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            error={!(!errors?.item.error)}
                            helperText={errors?.item.error}
                            style={{ width: '100%' }}
                            required
                        />
                    </ContainerInput>

                    <ContainerInput>
                        <CustomFormLabel>{t('riskLevel.table.impactLevel')}:</CustomFormLabel> {/* Se cambia impactLevel nombre a Gravedad en los 3 idiomas, solo label. */}
                        <SelectInput
                            placeholder={t('riskLevel.table.impactLevel')}
                            onChange={(e) => handleChange(e, 'impactLevel')}
                            value={form.impactLevel}
                            options={impactOptions}
                            keyValue="code"
                            size="small"
                            width={"100%"}
                        />
                    </ContainerInput>

                    <ContainerInput>
                        <CustomFormLabel>{t('riskLevel.table.probability')}:</CustomFormLabel>
                        <SelectInput
                            placeholder={t('riskLevel.table.probability')}
                            onChange={(e) => handleChange(e, 'probability')}
                            value={form.probability}
                            options={probabilityOptions}
                            keyValue="code"
                            size="small"
                            width={"100%"}
                        />
                    </ContainerInput>

                    {!isNew &&
						<ContainerInput>
							<CustomFormLabel>&nbsp;</CustomFormLabel>
							<AntSwitchBorderedControlLabel
								control={
									<AntSwitch
										checked={form.isActive}
										onChange={() => handleState(!form.isActive)}
										inputProps={{ 'aria-label': 'controlled' }}
									/>
								}
								label={
									<TextSwitch enabled={form.isActive}>{form.isActive ? t('system.active') : t('system.inactive')}</TextSwitch>
								}
							/>
						</ContainerInput>
                    }

                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput isFull>
                        <CustomFormLabel>{t('riskLevel.table.description')}:</CustomFormLabel>
                        <CustomTextArea
                            type='text'
                            value={form.description}
                            size="small"
                            onChange={e => handleChange(e, 'description')}
                            error={!(!errors?.description.error)}
                            helperText={errors?.description.error}
                            style={{ width: '100%'}}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>

                    <ContainerInput>
                        <CustomFormLabel>{t('riskLevel.table.riskLevel')}:</CustomFormLabel>
                        <SelectInput
                            placeholder={t('riskLevel.table.riskLevel')}
                            onChange={(e) => handleChange(e, 'riskLevel')}
                            value={form.riskLevel}
                            options={riskOptions}
                            keyValue="code"
                            size="small"
                            width={"55%"}
                            disabled
                        />
                    </ContainerInput>
                </ContainerGroup>

				<RiskImg sx={{ mt: 2 }} src={matrizPng} alt=""></RiskImg>

            </ContainerContent>
        </ContainerBox>
    )
}